import {Stack, Typography, Button, Box} from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import React, {useEffect, useRef, useState} from 'react';
import mainLogo from '../../../images/black_letters_with_blue_shadow.svg';
import DynamicProgressBar from '../../../components/progressBars/dynamicProgressBar';
import {getClientConfig} from '../../../config/clientThemes';
import {Link, useLocation, useNavigate} from 'react-router-dom';
import getHealthFunctions from '../helperfunctions';
import ResultsDialog from '../../DoktorConnect/components/doktorcreditspopup';
import {ratingsToObj} from '../helperfunctions';
import ShareButtons from '../../../components/buttons/ShareButtons';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import HealthCategoryNav from '../../../components/NavigationBar/HealthCategoryNavigationBar';
import {identifyClientType} from '../../../utils/identifyClientType';
import {CLIENT_TYPES} from '../../../api/clientconfig';

export const CarouselPage = ({
  item,
  handleUpgradeToSeeResults,
  onBackBtnClick,
  isShowAllResultsCard,
  isLastRrsultCard = false,
  isHandleOverlayVisibilty,
  getCategories,
  activeCategoryIndex,
  handleCategorySelect,
}) => {
  const location = useLocation();
  const isClientResultsUrl = location.pathname.includes('client-results');
  console.log(isClientResultsUrl);
  const cardRef = useRef(null);
  const navigate = useNavigate();
  const [ShadowClass, setShadowClass] = useState(true);
  const [progress, setProgress] = React.useState(90);
  const [blurAndHide, setBlurAndHide] = useState(false);

  React.useEffect(() => {
    // Simulate progress change (remove if not needed)
    const timer = setTimeout(() => setProgress(Math.min(progress + 90, 90)), 1000);
    return () => clearTimeout(timer);
  }, [progress]);

  // const isSmallScreen = useMediaQuery(theme => theme.breakpoints.down('sm'));
  const isSmallScreen = useMediaQuery('(max-width:499px)');
  const isGalaxyFold = useMediaQuery('(max-width:280px)');

  const isLargeScreen = useMediaQuery(theme => theme.breakpoints.up('lg'));

  const healthFunctions = getHealthFunctions(item.name);
  const scaledValue = healthFunctions.getValue(item.value);
  const statusColor = healthFunctions.getColor(item.value);
  const statusText = healthFunctions.getStatus(item.value);
  const paramValue = healthFunctions.getScaledValue(item.value);

  const [isFromDoktor, setIsFromDoktor] = useState(false);
  const [isAtplFlow, setIsAtplFlow] = useState(window.localStorage.getItem('from_atp') === 'true' ? true : false);
  const [isHelloHealthFlow, setIsHelloHealthFlow] = useState(
    window.localStorage.getItem('from_hellohealth') === 'true' ? true : false,
  );

  useEffect(() => {
    // Check localStorage for the flag
    const fromDoktor = window.localStorage.getItem('from_doktor');
    setIsFromDoktor(fromDoktor === 'true');
  }, []);

  const [clientType, setClientType] = useState(CLIENT_TYPES.DEFAULT);
  const config = getClientConfig(clientType);

  useEffect(() => {
    setClientType(identifyClientType());
  }, []);

  // Recalculate blur effect whenever any of the dependencies change
  useEffect(() => {
    const blurCondition = shouldBlur(
      item,
      isShowAllResultsCard,
      isFromDoktor,
      item?.isGameCompleted,
      isClientResultsUrl,
    );

    setBlurAndHide(blurCondition); // Set the boolean state to true/false based on the condition
  }, [isShowAllResultsCard, item, isFromDoktor, item?.isGameCompleted, isClientResultsUrl, clientType]);

  // Helper function to check the blur condition
  const shouldBlur = (item, isShowAllResultsCard, isFromDoktor, isGameCompleted, isClientResultsUrl) => {
    const blurCategories = ['Physical Health', 'Skin Health', 'Overall Disease Risk', 'Metabolic Health'];

    // Check if the category is one of the blur categories
    const isBlurCategory = blurCategories.includes(item.name);

    // Logic for blurring the card
    return (
      (clientType === CLIENT_TYPES.DEFAULT && !isShowAllResultsCard && isBlurCategory) ||
      (isFromDoktor && !isGameCompleted && !isClientResultsUrl && isBlurCategory)
    );
  };

  return isLargeScreen ? (
    <Stack
      display="flex"
      flexDirection="row"
      spacing={2}
      alignItems="center"
      justifyContent="center"
      sx={{width: 1}}
      marginTop={clientType == CLIENT_TYPES.DOKTOR_CONNECT ? '24px' : undefined}
      className="results-page-wrapper"
    >
      <Stack className="result-page-card" padding={2} ref={cardRef}>
        <Stack
          display="flex"
          flexDirection="row"
          spacing={2}
          alignItems="center"
          justifyContent="center"
          sx={{width: 1}}
          className="results-page-wrapper"
        >
          <Stack className="result-page-card large-card" padding={3} sx={{backgroundColor: 'transparent'}}>
            <Stack className="large-result-component">
              {/* Symptom Result Compoent Starts */}
              <Stack className={ShadowClass ? 'result-component card-gradient large' : 'result-component large'}>
                {/* Result heading */}
                <Stack padding={2}>
                  <Typography
                    color="black"
                    variant="h4"
                    component="h4"
                    fontWeight="700"
                    sx={{
                      fontSize: isGalaxyFold ? '18px' : isSmallScreen ? '22px' : '22px',
                    }}
                  >
                    {item.resultHeading}
                  </Typography>
                </Stack>
                {/* Result heading / */}

                {/* Linear Progress Starts */}
                <Stack>
                  {item.results.map((result, index) => {
                    const ratingObj = ratingsToObj(result.ratings, result.value);

                    return (
                      <Stack key={index} paddingLeft={3} paddingRight={3} marginBottom={2} className="progress-item">
                        <Stack className="prograss-bar">
                          <Typography
                            color="black"
                            variant="h4"
                            component="h4"
                            fontWeight="600"
                            sx={{
                              fontSize: isGalaxyFold ? '17px' : isSmallScreen ? '17px' : '17px',
                            }}
                          >
                            {result.name}
                          </Typography>
                          {ratingObj && (
                            <Stack display="flex" flexDirection="row" marginTop="4px">
                              <img
                                src={ratingObj?.icon}
                                className="s-icon"
                                alt=""
                                style={{
                                  filter: blurAndHide ? 'blur(20px)' : 'blur(0px)',
                                }}
                              />
                              <Typography
                                color={blurAndHide ? 'black' : ratingObj?.color}
                                variant="p"
                                component="p"
                                fontWeight="700"
                                sx={{
                                  fontSize: isGalaxyFold ? '12px' : isSmallScreen ? '12px' : '12px',
                                  paddingLeft: '4px',
                                  filter: blurAndHide ? 'blur(12px)' : 'blur(0px)',
                                }}
                              >
                                {ratingObj?.text}
                              </Typography>
                            </Stack>
                          )}
                        </Stack>

                        <Stack display="flex" flexDirection="row" alignItems="center">
                          <Typography
                            color="black"
                            variant="h4"
                            component="h4"
                            fontWeight="700"
                            sx={{
                              fontSize: isGalaxyFold ? '23px' : isSmallScreen ? '23px' : '23px',
                              marginRight: !result.symbol ? '0px' : '15px',
                              filter: blurAndHide ? 'blur(10px)' : 'blur(0px)',
                            }}
                          >
                            {Math.round(result.value)}
                            {result.diastolicbp != null && `/${Math.round(result.diastolicbp)}`}
                            {result.percentSign}
                          </Typography>
                          <Stack
                            display={clientType === CLIENT_TYPES.DEFAULT && !isShowAllResultsCard ? 'none' : 'flex'}
                            justifyContent="center"
                            alignItems="center"
                          >
                            {result.symbol != null && <img src={result.symbol} width="26" height="23" alt="" />}
                            <Typography
                              color="rgba(0, 0, 0, 0.65)"
                              variant="p"
                              component="p"
                              fontWeight="700"
                              sx={{
                                fontSize: isGalaxyFold ? '10px' : isSmallScreen ? '10px' : '10px',
                                marginTop: '4px',
                              }}
                            >
                              {result.label}
                            </Typography>
                          </Stack>
                        </Stack>
                      </Stack>
                    );
                  })}
                </Stack>
                {/* Linear Progress Ends */}

                <Box className="result-logo" sx={{marginBottom: '18px'}}>
                  <img src={config.logos.main} height={config.logos.height} className="" />
                  {clientType !== CLIENT_TYPES.DEFAULT && (
                    <Typography sx={{fontSize: '14px'}}>
                      Your health scan was powered by
                      <img src={mainLogo} className="custom-main-logo-for-md" />
                    </Typography>
                  )}
                </Box>

                <Box></Box>
              </Stack>
              {/* Symptom Result Compoent Ends */}
            </Stack>
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  ) : (
    <Stack
      display="flex"
      flexDirection="row"
      spacing={2}
      alignItems="center"
      justifyContent="center"
      sx={{width: 1}}
      className="results-page-wrapper"
    >
      <Stack
        className="result-page-card"
        padding={isGalaxyFold ? 1 : 3}
        paddingTop="1px"
        sx={{backgroundColor: '#fff'}}
      >
        <Stack
          sx={{
            display: 'flex',
            flexDirection: 'row',
            width: '100%',
            justifyContent: 'space-between',
            padding: isSmallScreen ? '2px 0px' : '4px 0px',
            alignItems: 'center',
          }}
        >
          <Box onClick={onBackBtnClick} style={{textDecoration: 'none'}}>
            <Stack display="flex" flexDirection="row" style={{cursor: 'pointer'}}>
              {!isFromDoktor && config?.backButton}
            </Stack>
          </Box>
          <Stack sx={{display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: '13px'}}>
            <Typography
              sx={{
                cursor: 'pointer',
                color: config?.colors?.primary,
                variant: 'p',
                component: 'p',
                fontWeight: '600',
                fontSize: '14px',
                textAlign: 'end',
              }}
              onClick={() => {
                const nextUrl = config?.urls?.nextButtonUrl;
                const isExternal = nextUrl.startsWith('http');

                if (isExternal) {
                  window.open(nextUrl, '_blank'); // Open external URL in new tab
                } else {
                  navigate(nextUrl); // Internal route
                }
              }}
            >
              Next
            </Typography>
            <ArrowForwardIcon
              sx={{fontSize: '16px', padding: '0px 2px 0px 4px', cursor: 'pointer', color: config?.colors?.primary}}
            />
          </Stack>
        </Stack>
        <Stack>
          {/* Top Header Starts */}
          <Stack
            className="top-header"
            display="flex"
            alignItems="center"
            flexDirection="row"
            justifyContent="space-between"
            sx={{position: 'relative', bottom: isAtplFlow || isHelloHealthFlow ? '15px' : '0px'}}
          >
            <Stack>
              <Typography
                color="black"
                variant="h4"
                component="h4"
                fontWeight="bold"
                sx={{
                  fontSize: isGalaxyFold ? '16px' : isSmallScreen ? '18px' : '23px',
                }}
              >
                {item.name}
              </Typography>
              <Typography
                color={statusColor}
                variant="p"
                component="p"
                fontWeight="600"
                sx={{
                  fontSize: isGalaxyFold ? '12px' : isSmallScreen ? '14px' : '15px',
                  filter: blurAndHide ? 'blur(6px)' : 'blur(0px)',
                }}
              >
                {statusText}
              </Typography>
            </Stack>
            <div
              style={{
                position: 'relative',
                width: '80px',
                height: isSmallScreen ? '64px' : '80px',
                background: '#fff', // Add a contrasting background color
              }}
            >
              <Box
                position="relative"
                display="flex"
                justifyContent="center"
                alignItems="center"
                width="100%"
                height="100%"
              >
                <DynamicProgressBar
                  paramValue={blurAndHide ? '100' : Number(Math.round(paramValue))}
                  barColor={blurAndHide ? '#D9D9D9' : statusColor}
                  paramSize={isGalaxyFold ? 60 : isSmallScreen ? 50 : 70}
                  paramThickness={isGalaxyFold ? 6 : isSmallScreen ? 5 : 8}
                />

                <Typography
                  variant="h6"
                  style={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                  }}
                  sx={{
                    fontWeight: 'bold',
                    filter: blurAndHide ? 'blur(6px)' : 'blur(0px)',
                  }}
                >
                  {Number(Math.round(item.value))}
                </Typography>
              </Box>
            </div>
          </Stack>
          {/* Top Header Ends */}

          {/* Symptom Result Compoent Starts */}
          <Stack
            ref={cardRef}
            className={`${ShadowClass ? 'result-component card-gradient' : 'result-component'} ${clientType !== CLIENT_TYPES.DEFAULT ? 'result-component-org' : ''}`}
            sx={{
              position: 'relative',
              bottom:
                isAtplFlow || isHelloHealthFlow
                  ? '50px'
                  : config?.resultPageSlider?.isResultPageSliderVisible
                    ? '30px'
                    : '0px',
            }}
          >
            {/* resultHeading */}
            <Stack>
              <Typography
                color="black"
                variant="h4"
                component="h4"
                fontWeight="700"
                sx={{
                  fontSize: isGalaxyFold ? '16px' : isSmallScreen ? '22px' : '22px',
                }}
              >
                {item.resultHeading}
              </Typography>
            </Stack>
            {/* Result heading / */}

            {/* Linear Progress Starts */}
            <Stack paddingTop={2}>
              {item.results.map((result, index) => {
                const ratingObj = ratingsToObj(result.ratings, result.value);

                return (
                  <Stack
                    key={index}
                    paddingLeft={isGalaxyFold ? 1 : 3}
                    paddingRight={isGalaxyFold ? 1 : 3}
                    marginBottom={2}
                    className="progress-item"
                  >
                    <Stack className="prograss-bar">
                      <Typography
                        color="black"
                        variant="h4"
                        component="h4"
                        fontWeight="600"
                        sx={{
                          fontSize: isGalaxyFold ? '14px' : isSmallScreen ? '14px' : '17px',
                        }}
                      >
                        {result.name}
                      </Typography>
                      {ratingObj && (
                        <Stack display="flex" flexDirection="row" marginTop="4px">
                          <img
                            src={ratingObj?.icon}
                            className="s-icon"
                            alt=""
                            style={{
                              filter: blurAndHide ? 'blur(20px)' : 'blur(0px)',
                            }}
                          />
                          <Typography
                            color={
                              isFromDoktor &&
                              !item?.isGameCompleted &&
                              !isClientResultsUrl &&
                              (item.name === 'Physical Health' ||
                                item.name === 'Overall Disease Risk' ||
                                item.name === 'Metabolic Health')
                                ? 'black'
                                : ratingObj?.color
                            }
                            variant="p"
                            component="p"
                            fontWeight="700"
                            sx={{
                              fontSize: isGalaxyFold ? '10px' : isSmallScreen ? '10px' : '12px',
                              paddingLeft: '4px',
                              filter: blurAndHide ? ' blur(12px)' : 'blur(0px)',
                            }}
                          >
                            {ratingObj?.text}
                          </Typography>
                        </Stack>
                      )}
                    </Stack>

                    <Stack display="flex" flexDirection="row" alignItems="center">
                      <Typography
                        color="black"
                        variant="h4"
                        component="h4"
                        fontWeight="700"
                        sx={{
                          fontSize: isGalaxyFold ? '18px' : isSmallScreen ? '18px' : '23px',
                          marginRight: !result.symbol ? '0px' : '15px',
                          filter: blurAndHide ? 'blur(8px)' : 'blur(0px)',
                        }}
                      >
                        {Math.round(result.value)}
                        {result.diastolicbp != null && `/${Math.round(result.diastolicbp)}`}
                        {result.percentSign}
                      </Typography>
                      <Stack
                        display={clientType === CLIENT_TYPES.DEFAULT && !isShowAllResultsCard ? 'none' : 'flex'}
                        justifyContent="center"
                        alignItems="center"
                      >
                        {result.symbol != null && (
                          <img
                            src={result.symbol}
                            width={isSmallScreen ? '24' : '26'}
                            height={isSmallScreen ? '18' : '23'}
                            alt=""
                          />
                        )}
                        <Typography
                          color="rgba(0, 0, 0, 0.65)"
                          variant="p"
                          component="p"
                          fontWeight="700"
                          sx={{
                            fontSize: isGalaxyFold ? '10px' : isSmallScreen ? '8px' : '10px',
                            marginTop: '4px',
                          }}
                        >
                          {result.label}
                        </Typography>
                      </Stack>
                    </Stack>
                  </Stack>
                );
              })}
            </Stack>
            {/* Linear Progress Ends */}

            <Box
              className="result-logo"
              sx={{marginBottom: clientType !== CLIENT_TYPES.DEFAULT && isSmallScreen ? '1px' : '18px'}}
            >
              <img src={config.logos.main} height={config.logos.height} className="" />
              {clientType !== CLIENT_TYPES.DEFAULT && (
                <Typography
                  sx={{
                    fontSize: isGalaxyFold ? '8px' : '10px',
                    display: 'flex',
                    alignItems: 'center',
                    width: '100%',
                    paddingTop: '8px',
                    justifyContent: 'center',
                  }}
                >
                  Your health scan was powered by
                  <img src={mainLogo} className="custom-main-logo" />
                </Typography>
              )}
            </Box>
          </Stack>
          {/* Symptom Result Compoent Ends */}
          <Box
            sx={{
              position: 'relative',
              bottom:
                isAtplFlow || isHelloHealthFlow
                  ? '50px'
                  : config?.resultPageSlider?.isResultPageSliderVisible
                    ? '30px'
                    : '0px',
            }}
          >
            {config?.resultPageSlider?.isResultPageSliderVisible && (
              <HealthCategoryNav
                categories={getCategories}
                activeIndex={activeCategoryIndex}
                onSelectCategory={handleCategorySelect}
                isLargeScreen={false}
                clientBaseNavCss={{
                  arrowColor: config?.resultPageSlider?.arrowColor,
                  arrowHOverColor: config?.resultPageSlider?.arrowHOverColor,
                  movingIndicatorColor: config?.resultPageSlider?.movingIndicatorColor,
                }}
              />
            )}
          </Box>

          <Stack className="bottom-info">
            <Typography
              color="black"
              marginTop="16px"
              variant="p"
              component="p"
              fontWeight="400"
              sx={{
                fontSize: isGalaxyFold ? '10px' : isSmallScreen ? '10px' : '12px',
                position:
                  isAtplFlow || isHelloHealthFlow || config?.resultPageSlider?.isResultPageSliderVisible
                    ? 'relative'
                    : null,
                bottom:
                  isAtplFlow || isHelloHealthFlow
                    ? '50px'
                    : config?.resultPageSlider?.isResultPageSliderVisible
                      ? '30px'
                      : '0px',
              }}
            >
              These numbers are only estimates and are not a substitute for the judgment of a healthcare professional.
              They are intended to improve awareness and general wellness.
            </Typography>

            <Box
              marginTop="20px"
              sx={{
                position:
                  isAtplFlow || isHelloHealthFlow || config?.resultPageSlider?.isResultPageSliderVisible
                    ? 'relative'
                    : null,
                bottom:
                  isAtplFlow || isHelloHealthFlow
                    ? '50px'
                    : config?.resultPageSlider?.isResultPageSliderVisible
                      ? '30px'
                      : '0px',
              }}
            >
              {isFromDoktor &&
              !item?.isGameCompleted &&
              !isClientResultsUrl &&
              (item.name === 'Physical Health' ||
                item.name === 'Overall Disease Risk' ||
                item.name === 'Metabolic Health') ? (
                <Box sx={{display: 'flex', justifyContent: 'center', width: '100%'}}>
                  <ResultsDialog isHandleOverlayVisibilty={data => isHandleOverlayVisibilty(data)} />
                  {/* <Box className='doktor-landing-footer'>
                      <img src="/product.png" alt='product' />
                    </Box> */}
                </Box>
              ) : clientType == CLIENT_TYPES.DEFAULT && blurAndHide ? (
                <>
                  {/* JSX to show only aimd basic plan user */}
                  <Stack
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'center',
                      width: '100%',
                      alignItems: 'center',
                    }}
                  >
                    <Typography
                      sx={{
                        color: 'rgba(0, 0, 0, 0.69)',
                        fontSize: '14px',
                        fontWeight: 600,
                        lineHeight: '17px',
                        textAlign: 'center',
                        padding: '2px 8px 10px 8px',
                      }}
                    >
                      $2.99 per week
                    </Typography>
                    <Button
                      fullWidth
                      className={'btn-shadow'}
                      sx={{
                        height: isSmallScreen ? '50px' : '60px',
                        borderRadius: isFromDoktor || isAtplFlow || isHelloHealthFlow ? '10px' : '40px',
                        marginBottom: isSmallScreen ? '6px' : '10px',
                        background: config.button.background,
                        maxWidth: '400px',
                        textAlign: 'center',
                        color: '#fff',
                        '&:hover': {
                          color: 'black',
                        },
                      }}
                    >
                      <Typography
                        className="btn-txt"
                        variant="p"
                        component="p"
                        fontWeight="600"
                        onClick={handleUpgradeToSeeResults}
                        sx={{
                          fontSize: isSmallScreen ? '16px' : '20px',
                        }}
                      >
                        🚀 Upgrade to See Results
                      </Typography>
                    </Button>
                    <Typography
                      sx={{
                        color: '#35C6C9',
                        fontSize: isSmallScreen ? '18px' : '20px',
                        fontWeight: 600,
                        lineHeight: '25px',
                        textAlign: 'center',
                        padding: '10px 0px',
                      }}
                    >
                      I’d Rather Invite Friends to View My Results... 👯‍♀️
                    </Typography>
                  </Stack>
                </>
              ) : (
                <>
                  <Link to="/results/analysis" state={{item}} className="analysis-link">
                    <Button
                      fullWidth
                      className={'btn-shadow'}
                      sx={{
                        height: isSmallScreen ? '50px' : '60px',
                        borderRadius: isFromDoktor || isAtplFlow || isHelloHealthFlow ? '10px' : '40px',
                        marginBottom: isSmallScreen ? '6px' : '10px',
                        background: config.button.background,
                        maxWidth: '400px',
                        textAlign: 'center',
                        color: '#fff',
                        '&:hover': {
                          color: 'black',
                        },
                      }}
                    >
                      <Typography
                        className="btn-txt"
                        variant="p"
                        component="p"
                        fontWeight="600"
                        sx={{
                          fontSize: isSmallScreen ? '16px' : '20px',
                        }}
                      >
                        👀 Find Products That Can Help
                      </Typography>
                    </Button>
                  </Link>
                  {/* Footer Starts */}
                  <ShareButtons cardRef={cardRef} item={item} socialButtonsCss={config?.socialButtons} />
                  {/* Footer Ends */}
                </>
              )}
            </Box>
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  );
};
